import { ThemeProvider } from '@mui/material/styles';
import { lazy, Suspense } from 'react';
import { ErrorBoundary, Loader } from './components/shared';
import { PerformanceDebugger } from './components/shared/debug/PerformanceDebugger';
import { StockProvider } from './contexts/StockContext';
import { AppLayout, CssBaseline, muiTheme } from './design-system';
import { QueryProvider } from './providers/QueryProvider';

const StockTradingDashboard = lazy(() =>
  import('./components/StockTrading/StockTradingDashboard').then(module => ({
    default: module.StockTradingDashboard,
  }))
);

function App() {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <QueryProvider>
        <StockProvider>
          <ErrorBoundary>
            <main aria-label="Stock trading dashboard application">
              <AppLayout>
                <Suspense fallback={<Loader variant="dashboard" />}>
                  <StockTradingDashboard />
                </Suspense>
              </AppLayout>
            </main>
          </ErrorBoundary>
        </StockProvider>
      </QueryProvider>
      <PerformanceDebugger />
    </ThemeProvider>
  );
}

export default App;
